angular.module('gym.components').controller('SendInvitationSmsCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "TemplateSanitizeService", "template", "baseUrl", "isUnsubscribedFromMobile", function($scope, $rootScope, $modalInstance, $http, TemplateSanitizeService, template, baseUrl, isUnsubscribedFromMobile) {
  $scope.template = template;
  $scope.gym = $rootScope.gym;
  $scope.isUnsubscribedFromMobile = isUnsubscribedFromMobile;
  $scope.submit = function() {
    var data, params, url;
    $scope.isLoading = true;
    data = TemplateSanitizeService.sanitize($scope.template);
    params = {
      invite_sms_content: data.content
    };
    url = `${baseUrl}/send_invitation_sms`;
    return $http.put(url, params).then(function() {
      return $modalInstance.close();
    }, function(response) {
      $scope.error = response.data.error_message;
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
